import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (e) {
      //console.log('User model: error', e)
      return null
    }
  }

  constructor ({ user_id, email, first_name, last_name, slack_user, avatar_url, roles, default_dashboard_id, dc_user_id }) { // eslint-disable-line camelcase
    this.id = user_id // eslint-disable-line camelcase
    this.email = email
    this.firstName = first_name
    this.lastName = last_name
    this.slackUser = slack_user // eslint-disable-line camelcase
    this.avatar = avatar_url || '/img/avatars/default_avatar.png'
    this.dc_user_id = dc_user_id
    this.roles = roles
    this.isAdmin = roles.includes('admin')
    this.isDigital = roles.includes('digital') || roles.includes('admin')
    this.isAgency = roles.includes('agency') || roles.includes('admin') || roles.includes('digital')
    this.isClient =  roles.includes('client') || roles.includes('agency') || roles.includes('admin') || roles.includes('digital')
    this.defaultDashboardId = parseInt(default_dashboard_id, 10)
  }
}
